import { motion } from "framer-motion";
import { PlayCircle } from "lucide-react";
import { VIDEOS } from "@/data/site";

export const VideoShowcase = () => {
  return (
    <section id="our-work" data-testid="video-section" className="py-16 sm:py-20 lg:py-28 bg-slate-950">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] font-bold text-red-600">
            <PlayCircle className="h-4 w-4" /> See Us In Action
          </span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
            Watch the Craftsmanship For Yourself
          </h2>
          <p className="mt-4 text-lg text-slate-300 leading-relaxed">
            Real footage from real Templar Armor job sites across California.
          </p>
        </div>

        <div className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {VIDEOS.map((v, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`video-${i}`}
              className="flex flex-col rounded-2xl overflow-hidden border border-white/10 bg-white/5"
            >
              <video
                src={v.src}
                controls
                playsInline
                preload="metadata"
                className="w-full aspect-video object-cover bg-black"
              />
              <div className="p-5 flex-1">
                <h3 className="font-display font-bold text-lg sm:text-xl text-white">{v.title}</h3>
                <p className="mt-1.5 text-slate-300 leading-relaxed text-sm sm:text-base">{v.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
